import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap'
import {toastr} from 'react-redux-toastr'

import SubmitButton from '../../Forms/CertificationForm/SubmitButton.jsx'
import Modal from "../Modal.jsx"
import CertificationForm from "../../Forms/CertificationForm/CertificationForm.jsx"

export default class CertificationModal extends Modal {
  onSubmitSuccess = () => {
    const action = (this.props.offset !== undefined) ?
      'modifiée' : 'créée'
    toastr.success(`La certification a été ${action} avec succès.`)
  }

  onSubmit = (values) => {
    const {freelance} = this.props
    const certifications = this.props.freelance?.certifications?.length ? this.props.freelance.certifications : []
    if (this.props.offset !== undefined) {
      certifications[this.props.offset] = values
    } else {
      certifications.push(values)
    }

    if (this.props.onSubmit) {
      this.props.onSubmit({
        freelance: {...freelance, certifications}
      })
    }

    if (this.props.onClose) {
      this.props.onClose(certifications)
    }

    this.props.closeModal()
  }

  render() {
    if (!this.props.freelance) {
      return null
    }

    const certifications = (this.props.offset !== undefined && this.props.freelance.certifications[this.props.offset]) || null

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg" >
        <ModalHeader toggle={this.props.closeModal}>Certifications</ModalHeader>
        <ModalBody>
          <CertificationForm
            onSubmitSuccess={this.onSubmitSuccess}
            initialValues={certifications}
            onSubmit={this.onSubmit}
            className={'mt-4'}
          />
          <div className="text-center">
            <SubmitButton className="btn btn-primary my-3">
              Enregistrer
            </SubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}
